<div class="min-h-screen w-full min-w-0 overflow-x-hidden bg-cloud-mist">
  <div class="tfr-page-shell py-6">

    <header class="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div class="min-w-0">
        <h1 class="text-[22px] font-bold tracking-tight text-midnight-indigo sm:text-[24px]">
          Panel CRM &middot; Captaci&oacute;n
        </h1>
      </div>
      <a routerLink="/admin/dashboard"
         class="inline-flex shrink-0 items-center gap-1.5 rounded-xl border border-pale-gray bg-white px-4 py-2 text-[12px] font-semibold text-steel-gray transition hover:border-slate-300">
        Cerrar
      </a>
    </header>

    <nav class="mb-5 flex gap-1 border-b border-pale-gray" aria-label="Secciones CRM">
      <a routerLink="/admin/crm/leads"
         routerLinkActive="border-action-blue text-action-blue"
         [routerLinkActiveOptions]="{ exact: true }"
         class="-mb-px border-b-2 border-transparent px-4 py-2.5 text-[13px] font-semibold text-steel-gray transition hover:text-midnight-indigo">
        Leads
      </a>
      <a routerLink="/admin/crm/pipelines"
         routerLinkActive="border-action-blue text-action-blue"
         class="-mb-px border-b-2 border-transparent px-4 py-2.5 text-[13px] font-semibold text-steel-gray transition hover:text-midnight-indigo">
        Pipelines
      </a>
    </nav>

    <router-outlet />
  </div>
</div>
